import { Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormGroup, Grid, IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DashboardContainer from '../../components/DashboardContainer'
import PageContainer from '../../components/PageContainer'
import { AddorUpdateRecord, getFields, getList } from '../../redux/api/system'
import { Formik, Form } from 'formik'
import { useSnackbar } from 'notistack'
import { DataGrid } from '@mui/x-data-grid';
import TextInput from '../../components/common/TextInput';
import SelectInput from '../../components/common/SelectInput';
import { Add, ApartmentOutlined, BusinessOutlined, Delete, DomainAddOutlined, Edit, Label } from '@mui/icons-material'
import { dataTypeOptions } from '../../util'
import { Link } from 'react-router-dom';
import SubtitlesOffIcon from '@mui/icons-material/SubtitlesOff';
import CustomDataGrid from '../../components/CustomDataGrid'

const Datasets = () => {

    const defaultDataset = {
        "domainID": "",
        "dataSetName": "",
        "dB_Table": "",
        "fields": [
            {
               "fieldName": "",
               "fieldMaxLenght": 0,
               "dataType": "",
               "friendlyName": ""
            },
        ],
        "type": "",
        "producer": "",
        "searchTags": "",
        "ingestMedium":"",
        "frequency":"",
        "description":"",
        "deliveryMedium": "",
        "autoCreateResource": false,
        // 
    }

    const [ showModal, setShowModal ] = useState(false);
    const [ selectedDataset, setSelectedDataset ] = useState(defaultDataset);
    const [ records, setRecords ] = useState([]);
    const [ domains, setDomains ] = useState([]);
    const [ institutions, setInstitutions ] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const [ processing, setProcessing ] = useState(false)
    const [ mapConsumers, setMapConsumers ] = useState(false)
    const [ mapping, setMapping ] = useState(false);
    const [ deleteModal, setDeleteModal ] = useState(false);
    const [ isDeleting, setIsDeleting] = useState(false);




    const defaultField = {
        "fieldName": "",
        "fieldMaxLenght": 0,
        "dataType": "",
        "friendlyName": ""
    }

    const fetchFields = async (dataset) => {
        try {
            const resp = await getFields(dataset.id)
            if(resp?.responseCode === "00") {
                setSelectedDataset({ ...dataset, fields: resp?.listing?.sort((a, b) => (a.sequence < b.sequence) ? -1 : 1) || [] })
                setShowModal(true)
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch(err) {

        }
    }

    const columns = [
        { 
            field: 'sn', headerName: 'S/N', flex: 0.1, sortable: false,
            renderCell: (params) => (
                <p
                    style={{ margin: 'auto' }}
                >
                    {params?.row?.sn}
                </p>
            )
        },
        
        {
            field: 'actions', headerName: 'Actions', flex: 0.12, sortable: false,
            renderCell: (params) => (
                <div className='action-icons' style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', width: '100%', padding: '0 0.5rem' }}>
                    <IconButton
                        size='small'
                        color="primary"
                        variant="outlined" title='Edit Dataset' className='p-0 m-0'
                        onClick={() => {
                            fetchFields(params?.row);
                        }}
                    >
                        <Edit />
                    </IconButton>

                    {/* <IconButton
                        size='small'
                        color="primary"
                        variant="outlined" title='Set Consumers' className='p-0 m-0'
                        onClick={() => {
                            setSelectedDataset(params?.row);
                            setMapConsumers(true)
                        }}
                    >
                        <BusinessOutlined />
                    </IconButton> */}
                    <IconButton
                        size='small'
                        color="error"
                        variant="outlined" title='Delete Dataset' className='p-0 m-0'
                        onClick={() => {
                            setSelectedDataset(params?.row);
                            setDeleteModal(true)
                        }}
                    >
                        <SubtitlesOffIcon />
                    </IconButton>
                </div>
            )
        },
        { field: 'dataSetName', headerName: 'Datasets', flex: 1.2 },
    ];

    const addOrDeleteField = (key = null) => {
        if(key != null) {
            const newFields = selectedDataset.fields.filter((doc, index) => index !== key);
            setSelectedDataset({...selectedDataset, fields: newFields })
        } else {
            setSelectedDataset({...selectedDataset, fields: [ ...selectedDataset.fields, defaultField ] })
        }
    }

    const handleChange = (event, value) => {
        let newConsumers = [ ...selectedDataset?.consumers ] || [];
        if(value) {
            if(event.target.name == "001") {
                newConsumers = [ ...institutions?.map(({ id }) => ({ id }) ) ]
            } else {
                newConsumers.push({ id: event.target.name });
            }
        } else {
            if(event.target.name == "001") {
                newConsumers = []
            } else {
                newConsumers = newConsumers.filter(({ id }) => (id != event.target.name) && (id != "001"))
            }
            
        }
        setSelectedDataset({ ...selectedDataset, consumers: newConsumers })
    }

    const handleFieldChange = (name, value, key) => {
        let newDocs = [ ...selectedDataset.fields ]
        let doc = newDocs[key];
        const id = name.split(`${key}-`)[1]
        doc[id] = value;
        newDocs[key] = doc            
        setSelectedDataset({...selectedDataset, fields: newDocs })
    }

    const hasPrivilege = (id) => {
        return (selectedDataset?.consumers?.map(x => String(x?.id))?.indexOf(String(id)) >= 0) ? true : false
    }

    const handleMapping = async () => {
        try {
            setMapping(true)
            const resp = await AddorUpdateRecord("dataset", "update", selectedDataset);
            if(resp?.responseCode === "00") {
                init();
                setMapping(false);
                setSelectedDataset(defaultDataset)
                setMapConsumers(false)
                enqueueSnackbar('Mapping successful')
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', { variant: 'error' })
        }
        finally {
            setMapping(false)
        }
    };


    const init = async () => {
        try {
            setProcessing(true)
            const resp = await getList("datasets");
            const res = await getList("institutions");
            if(resp?.responseCode === "00") {
                setRecords(resp?.listing || [])
                setInstitutions(res?.listing || [])
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
        finally {
            setProcessing(false)
        }
    }

    const getDomains = async () => {
        try {
            setProcessing(true)
            const resp = await getList("domains");
            if(resp?.responseCode === "00") {
                setDomains(resp?.listing || [])
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
        finally {
            setProcessing(false)
        }
    }

    const createOrUpdateDataset = async (values, { resetForm }) => {
        try {
            const resp = await AddorUpdateRecord("dataset", values?.id ? "update" : 'add', values);
            if(resp?.responseCode === "00") {
                init();
                setSelectedDataset(defaultDataset);
                setShowModal(false);
               
                enqueueSnackbar('Action performed successfully');
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
    }

    const deleteDataset = async () => {
        try {
            setIsDeleting(true);

            const res = await AddorUpdateRecord("dataset", "delete", selectedDataset);

            if(res.responseCode === "00") {
                init();
                setSelectedDataset(null);
                setDeleteModal(false);
                enqueueSnackbar('Dataset deleted successfully', { variant: 'success' });
            }
            else {
                enqueueSnackbar(res?.message ?? res?.responseMessage ?? 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message ?? err?.responseMessage ?? 'An error occurred', { variant: 'error' })
        }
        finally {
            setIsDeleting(false);
        }
    }

    useEffect(() => {
        init()
        getDomains()
    }, [])

    return (
        <PageContainer pageTitle='Datasets' processing={processing}>
            <section className="inner-banner parallax-section">
                <div className='overlay'>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <h3 className="wow bounceIn" data-wow-delay="0.9s">Create</h3>
                                <h1 className="wow fadeInUp text-uppercase conference mb-05 mt-05" data-wow-delay="1.6s">Datasets</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="services-area section-padding pt-3">
                <div className="container">
                    <div className="row">
                        <div className='col-12 text-align-right'>
                            <Link to={'/internal/datasets/create'}>
                                <Button variant="contained">Create Dataset</Button>
                            </Link>
                        </div>
                        <div className='col-12 mt-4'>
                            <div style={{ height: 600, width: '100%', textAlign: 'center' }}>
                                <CustomDataGrid 
                                    columns={columns}
                                    rows={records}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog open={mapConsumers} maxWidth='lg'>
                <DialogTitle className='no-margin m-0 pt-2' style={{ textTransform: 'initial' }}>
                    <h4 className='m-0'>Map Resource to Institutions: <b>{selectedDataset?.dataSetName}</b></h4>
                </DialogTitle>
                <DialogContent style={{ height: '500px', width: '600px', padding: '0 2rem' }}>
                    <FormControl component="fieldset" variant="standard">
                        <FormGroup>
                            {
                                institutions.map((institution, key) => (
                                    <FormControlLabel
                                        control={
                                            <Checkbox checked={hasPrivilege(institution.id)} onChange={handleChange} name={institution.id} />
                                        }
                                        label={institution.institutionName} key={key}
                                    />
                                ))
                            }
                        </FormGroup>
                    </FormControl>
                </DialogContent>
                <DialogActions style={{ padding: '1rem' }}>
                    <Button onClick={() => { setMapConsumers(false); setSelectedDataset(defaultDataset) }} color='secondary' variant='contained'>Cancel</Button>

                    <Button onClick={handleMapping} color='primary' variant='contained'>
                        { mapping ? <CircularProgress size={15} color='inherit' /> : 'Save Mapping' }
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={showModal} maxWidth="lg">
                <Formik enableReinitialize initialValues={selectedDataset} onSubmit={createOrUpdateDataset}>
                    {({ isSubmitting, values, setFieldValue }) => (
                        <Form>
                            <DialogContent className='pl-4 pr-4'>
                                <h3 className='text-bold mt-05' >{values?.id ? 'Update' : 'Create'} Dataset</h3>
                                <Divider className="mt-05 mb-2" />
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <SelectInput id="domainID" required label="Domain" options={domains} field="domainID" fieldDisplay='domainName' 
                                            customChange={(name, value) => setSelectedDataset({ ...selectedDataset, [name]: value })} 
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextInput id="dataSetName" required label="Dataset Name"
                                            customChange={(name, value) => setSelectedDataset({ ...selectedDataset, [name]: value })} 
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextInput id="dB_Table" required label="Dataset Table name"
                                            customChange={(name, value) => setSelectedDataset({ ...selectedDataset, [name]: value })} 
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextInput id="description" label="Description" placeholder="" multiline minRows={2}
                                            customChange={(name, value) => setSelectedDataset({ ...selectedDataset, [name]: value })} 
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextInput id="searchTags" label="Search Tags" placeholder="Separate each with a comma"
                                            customChange={(name, value) => setSelectedDataset({ ...selectedDataset, [name]: value })} 
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextInput id="uniqueFields" label="Dataset Unique Fields" placeholder="Separate each with a comma"
                                            customChange={(name, value) => setSelectedDataset({ ...selectedDataset, [name]: value })} 
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <SelectInput required id="type" label="Dataset Type" options={[{ code: 'custom' }, { code: 'generic' }, { code: 'static report' }]} fieldDisplay="code" field="code"
                                            customChange={(name, value) => setSelectedDataset({ ...selectedDataset, [name]: value })} 
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <SelectInput required id="frequency" label="Dataset Frequency" options={[{ code: 'yearly' }, { code: 'quarterly' }, { code: 'monthly' }, { code: 'daily' }, { code: "bi-annually" }]} fieldDisplay="code" field="code"
                                            customChange={(name, value) => setSelectedDataset({ ...selectedDataset, [name]: value })} 
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <SelectInput required id="ingestMedium" label="Dataset Ingest Medium" options={[{ code: 'api' }, { code: 'file' }, { code: 'hybrid' }]} fieldDisplay="code" field="code"
                                            customChange={(name, value) => setSelectedDataset({ ...selectedDataset, [name]: value })} 
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <SelectInput required id="deliveryMedium" label="Dataset Delivery Medium" options={[{ code: 'api' }, { code: 'file' }, { code: 'hybrid' }]} fieldDisplay="code" field="code"
                                            customChange={(name, value) => setSelectedDataset({ ...selectedDataset, [name]: value })} 
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            control={ <Checkbox  /> }
                                            label={<b className='f-15'>Auto create Resource from Dataset</b>}
                                            name={"autoCreateResource"}
                                            onChange={({ target }) => {
                                                setFieldValue('autoCreateResource', target.checked)
                                                setSelectedDataset({ ...selectedDataset, autoCreateResource: target.checked })
                                            }}
                                            value={values.autoCreateResource}
                                        />
                                    </Grid>
                                    {/*               
                                        "fieldName": "",
                                        "fieldMaxLenght": 0,
                                        "dataType": "",
                                        "friendlyName": ""
                                    */}
                                    <Grid item xs={12}>
                                        <div className='d-flex justify-content-space-between align-items-center'>
                                            <label>Dataset Fields</label>

                                        </div>
                                            {
                                                values?.fields?.map((field, key) => (
                                                    <div key={key}>
                                                        <Divider className='mt-2 mb-2' />
                                                        <p><b>{key + 1}.</b></p>
                                                        <Grid container item spacing={2} xs={12}>
                                                            <Grid item xs={12} md={6} lg={4}>
                                                                <TextInput floatingLabel required multiline label="Field Name" 
                                                                    preventFormikSetValue id={`${key}-fieldName`}
                                                                    value={field.fieldName}
                                                                    customChange={(name, value) => {
                                                                        handleFieldChange(name, value, key)
                                                                    }} 
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} lg={4}>
                                                                <TextInput floatingLabel required multiline label="Field Friendly Name"
                                                                    preventFormikSetValue id={`${key}-friendlyName`}
                                                                    value={field.friendlyName}
                                                                    customChange={(name, value) => {
                                                                        handleFieldChange(name, value, key)
                                                                    }} 
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={4}>
                                                                <TextInput floatingLabel label="Max Length" type="number" 
                                                                    preventFormikSetValue id={`${key}-fieldMaxLenght`}
                                                                    value={field.fieldMaxLenght}
                                                                    customChange={(name, value) => {
                                                                        handleFieldChange(name, value, key)
                                                                    }} 
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={4}>
                                                                <SelectInput floatingLabel required label="Data Type" options={dataTypeOptions} fieldDisplay="code" field="code" 
                                                                    preventFormikSetValue id={`${key}-dataType`}
                                                                    value={field.dataType}
                                                                    customChange={(name, value) => {
                                                                        handleFieldChange(name, value, key)
                                                                    }} 
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={2}>
                                                                <TextInput floatingLabel label="Sequence" type="number" 
                                                                    preventFormikSetValue id={`${key}-sequence`}
                                                                    value={field.sequence}
                                                                    customChange={(name, value) => {
                                                                        handleFieldChange(name, value, key)
                                                                    }} 
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={4} container justifyContent={'flex-end'} flexDirection="column">
                                                                <Button color="error" startIcon={<Delete />} variant='outlined' onClick={() => addOrDeleteField(key)}>
                                                                    Remove
                                                                </Button>
                                                            </Grid>
                                                        </Grid>
                                                    </div>
                                                ))
                                            }
                                            <div className='d-flex justify-content-space-between align-items-center'>
                                                <Divider className='mt-2 mb-2' />
                                                <Button variant="outlined" className='mt-2' color="primary" onClick={() => addOrDeleteField()} startIcon={<Add />}>
                                                    Add
                                                </Button>
                                            </div>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions className='pr-3 pb-3'>
                                <Button disabled={isSubmitting} onClick={() => { if(!isSubmitting) { setShowModal(false); setSelectedDataset(defaultDataset) }}} color="secondary" variant="contained" >Cancel</Button>
                                <Button type='submit' variant="contained" disabled={isSubmitting}>
                                    {
                                        isSubmitting ?
                                        <CircularProgress size={15} color="inherit" />
                                        :
                                        values?.id ? 'Update Dataset Domain' : 'Add Dataset Domain'
                                    }
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>

            <Dialog open={deleteModal} maxWidth="lg">
                <DialogContent className='pl-4 pr-4'>
                    <p className='text-bold mt-05' style={{ fontSize: "1.2em" }} >Are you sure you want to <b style={{ color: "red" }}>delete the Dataset</b> from the system</p>
                    <Divider className="mt-2" />
                </DialogContent>
                <DialogActions className='pr-3 pb-3'>
                    <Button 
                        disabled={isDeleting} 
                        onClick={() => { 
                            if(!isDeleting) { 
                                setDeleteModal(false); 
                                setSelectedDataset(null) 
                            }}} 
                        color="secondary" 
                        variant="contained" >
                            Cancel
                        </Button>
                    <Button variant="contained" disabled={isDeleting} onClick={deleteDataset} >
                        {
                            isDeleting ?
                            <CircularProgress size={15} color="inherit" />
                            :
                            'Delete Dataset'
                        }
                    </Button>
                </DialogActions>
            </Dialog>
            
        </PageContainer>
    )
}

export default Datasets